module.exports = __webpack_public_path__ + "static/media/missforstand.3b93375b.mp3";